import React from 'react'
import Navbar from '../../Components/Navbar';
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"


const Analyticsdashboard = () => {
  return (
    <div>
      
      <Navbar />
      
      Analyticsdashboard
      <h2>Analytics dashboard</h2>
      <h3>testing to see if it works </h3>
    </div>
  )
}

export default Analyticsdashboard